import { environment } from './environment';

export const Endpoints = {
  security: {
    login: `${environment.baseUrl}/login?delay=2`,
    userInfo: `${environment.keycloak.url}/realms/omicron/protocol/openid-connect/userinfo`,
    updatePassword: `${environment.baseUrl}/api/dxp/catalog/update/userpass/keycloak`,
  },
  demo: {
    colors: `${environment.baseUrl}/unknown`,
  },
  cfdiList: `${environment.baseUrl}/api/dxp/doctors/cfdi/catalog`,
  shoppingCart: {
    shoppingCart: `${environment.baseUrl}/api/dxp/shoppingcart/cart`,
    checkMoreProducts: `${environment.baseUrl}/api/dxp/shoppingcart/cart/specific/product`,
    shoppingCartBase: `${environment.baseUrl}/api/dxp/shoppingcart`,
    ShopAgain: `${environment.baseUrl}/api/dxp/shoppingcart/cart/shop/again`,
    deliveryAndTax: `${environment.baseUrl}/api/dxp/shoppingcart/shoppingcartaddresses`,
    updateProductUtilities: `${environment.baseUrl}/api/dxp/pedidosdxp/utilities/`,
    validateLabel: `${environment.baseUrl}/api/dxp/shoppingcart/validate/shoppingcart?`,
    saveOneProductToSavedCart: `${environment.baseUrl}/api/dxp/shoppingcart/change/products/carts`,
    saveAllShoppingCart: `${environment.baseUrl}/api/dxp/shoppingcart/change/products/all/carts`,
    deleteAllShoppingCart: `${environment.baseUrl}/api/dxp/shoppingcart/cart/empty`,
    saveUtilityProducts: `${environment.baseUrl}/api/dxp/shoppingcart/cart/merge/products`,
    updatePrices: `${environment.baseUrl}/api/dxp/shoppingcart/cart/header`,
    getDefaultDirectionCost: `${environment.baseUrl}/api/dxp/catalog/calculateshippingcost/default`,
    creditNotes: `${environment.baseUrl}/api/dxp/processpayments/creditnotes/`,
    getTicks: `${environment.baseUrl}/api/dxp/shoppingcart/cart`,
    ShowPromotionalCodeMessage: `${environment.baseUrl}/api/dxp/catalog/params/contains/field?ShowPromotionalCodeMessage=ShowPromotionalCodeMessage`,
    validateMagistralProductsInCart: `${environment.baseUrl}/api/dxp/shoppingcart/validate/magistral/products`
  },
  favorites: {
    list: `${environment.baseUrl}/api/dxp/favorites/doctor`,
    saveDelete: `${environment.baseUrl}/api/dxp/favorites`,
    checkFavorite: `${environment.baseUrl}/api/dxp/favorites/specific/product`,
    filter: `${environment.baseUrl}/api/dxp/favorites/doctor/search`
  },
  catalogs: {
    list: `${environment.baseUrl}/api/dxp/catalog/products/labelContainer`,
    getContainercustomlabels: `${environment.baseUrl}/api/dxp/catalog/user/containercustomlabels?cardcode=`,
    listDerma: `${environment.baseUrl}/api/dxp/catalog/ailments`,
    missingProducts: `${environment.baseUrl}/api/dxp/catalog/params/contains/field?MissingProductType=MissingProductType`,
    invalidBusinessName: `${environment.baseUrl}/api/dxp/catalog/params/contains/field?InvalidBusinessName=InvalidBusinessName`,
    taxRegimen: `${environment.baseUrl}/api/dxp/catalog/taxregimes`,
    powerBiReportToken: `${environment.baseUrl}/api/dxp/catalog/report`,
  },
  profile: {
    myProfile: `${environment.baseUrl}/api/dxp/sapordersadapter/doctor/headerDetail`,
    directionsDelivered: `${environment.baseUrl}/api/dxp/sapordersadapter/doctor`,
    taxData: `${environment.baseUrl}/api/dxp/sapordersadapter/doctor/invoicedata`,
    doctorInfo: `${environment.baseUrl}/api/dxp/doctors/doctor/prescriptioninfo`,
    responsibleDoctorList: `${environment.baseUrl}/api/dxp/doctors/doctor/responsible`,
    saveDoctorInfo: `${environment.baseUrl}/api/dxp/doctors/doctor/saveprescriptioninfo`,
    saveDirectionDelivery: `${environment.baseUrl}/api/dxp/doctors/doctor/savedeliveryaddress`,
    imagesReceipt: `${environment.baseUrl}/api/dxp/doctors/doctor/recipe/images`,
    imagesReceiptSave: `${environment.baseUrl}/api/dxp/doctors/recipe/images`,
    signatureImgByTransaction: `${environment.baseUrl}/api/dxp/files/prescription/info/update`,
    saveTaxData: `${environment.baseUrl}/api/dxp/doctors/doctor/saveinvoicedata`,
    defaultAddress: `${environment.baseUrl}/api/dxp/doctors/doctor/default/info`,
    updateProfilePhoto: `${environment.baseUrl}/api/dxp/doctors/doctor/saveprofilepicture`,
    saveMyProfileInfo: `${environment.baseUrl}/api/dxp/doctors/doctor/saveprofileinfo`,
    getMyProfileInfo: `${environment.baseUrl}/api/dxp/doctors/doctor/profileinfo?`,
    crudRecipeAddress: `${environment.baseUrl}/api/dxp/doctors/prescription/address`,
    saveLicense: `${environment.baseUrl}/api/dxp/doctors/academic/info`,
    getCommentsCard: `${environment.baseUrl}/api/dxp/doctors/doctor/payment/client?`,
    saveClinicInfo: `${environment.baseUrl}/api/dxp/doctors/clinics/info`,
    shippingcost: `${environment.baseUrl}/api/dxp/catalog/calculateshippingcost?`,
    saveReporter: `${environment.baseUrl}/api/dxp/report/user/saveprofilepicture`,
    getReporterPhoto: `${environment.baseUrl}/api/dxp/report/reporter`,
    reCreateTransaction: `${environment.baseUrl}/api/dxp/processpayments/process/newspeicode/invoice`,
    saveResponsibleDoctor: `${environment.baseUrl}/api/dxp/doctors/doctor/responsible`,
    deleteResponsibleDoctor: `${environment.baseUrl}/api/dxp/doctors/doctor/responsible`,
    getResponsibleDoctors: `${environment.baseUrl}/api/dxp/doctors/doctor/responsible/doctors`
  },
  myProducts: {
    list: `${environment.baseUrl}/api/dxp/sapordersadapter/doctor/products`,
    detailRepurchase: `${environment.baseUrl}/api/dxp/sapordersadapter/details/orderpedidodxp`,
    detail: `${environment.baseUrl}/api/dxp/sapordersadapter/details/orderpedidodxp/patient`,
    detailPending: `${environment.baseUrl}/api/dxp/shoppingcart/detail/byPatient`,
    validateContainers: `${environment.baseUrl}/api/dxp/catalog/products/validatecontainer`,
    detailPendingAuthorization: `${environment.baseUrl}/api/dxp/shoppingcart/pendingauthorize/transaction/detail`,
    detailActiveOrders: `${environment.baseUrl}someUrl`,
    restoreCartSaved: `${environment.baseUrl}/api/dxp/shoppingcart/saved/cart/products`,
    recalculatePrices: `${environment.baseUrl}/api/dxp/processpayments/cart/changepayment`,
    validateProductPieces: `${environment.baseUrl}/api/dxp/ordervalidation/validate/productspieces`,
    filterProductsTop: `${environment.baseUrl}/api/dxp/sapordersadapter/doctor/products/search`
  },
  orders: {
    list: `${environment.baseUrl}/api/dxp/processpayments/orders/history`,
    delivered: `${environment.baseUrl}/api/dxp/processpayments/orders/delivered`,
    countOrders: `${environment.baseUrl}/api/dxp/processpayments/orders/countbydoctors`,
    detailTransaction: `${environment.baseUrl}/api/dxp/processpayments/orders/transactiondetail`,
  },
  zipCode: {
    detail: `${environment.baseUrl}/api/dxp/catalog/zipcode/`,
  },
  license: {
    detail: `${environment.baseUrl}/api/dxp/catalog/doctor/professionallicense?license=`,
  },
  ordersResume: {
    productsResume: `${environment.baseUrl}/api/dxp/shoppingcart/cart`,
    infoResume: `${environment.baseUrl}/api/dxp/doctors/doctor/order/prescription`,
    smsValidation: `${environment.baseUrl}/api/dxp/doctors/doctor/send/sms/prescription`,
    nipValidation: `${environment.baseUrl}/api/dxp/doctors/validate/nip`,
    previewReceipt: `${environment.baseUrl}/api/dxp/files/prescription`,
    confirmOrder: `${environment.baseUrl}/api/dxp/processpayments/process`,
    confirmOrderAdvisor: `${environment.baseUrl}/api/dxp/processpayments/advisor/order`,
    printOrder: `${environment.baseUrl}/api/dxp/files/quote`,
    createPaypalOrder: `${environment.baseUrl}/api/dxp/payments/payment/paypal`,
    savePaypalTransaction: `${environment.baseUrl}/api/dxp/shoppingcart/save/cart/transaction/detail`,
    cancelPaypalOrder: `${environment.baseUrl}/api/dxp/payments/order/cancel/paypal`,
  },
  pendingProducts: {
    list: `${environment.baseUrl}/api/dxp/processpayments/orders/pending`,
    changePaymentMethod: `${environment.baseUrl}/api/dxp/processpayments/process/changepayment`,
    detailProduct: `${environment.baseUrl}/api/dxp/processpayments/orders/pending/detail`,
    expiredCode: `${environment.baseUrl}/api/dxp/processpayments/process/bank/store/expired`,
    expiredSpeiCode: `${environment.baseUrl}/api/dxp/processpayments/process/bank/spei/expired`,
    deleteOrder: `${environment.baseUrl}/api/dxp/processpayments/cancel/order/logger`,
    authPrescription: `${environment.baseUrl}`,
    authOrder: `${environment.baseUrl}/api/dxp/processpayments/payment/authorize/transaction`,
    resendEmail: `${environment.baseUrl}/api/dxp/processpayments/orders/resend/authorizationmail`,
    getValidPackages: `${environment.baseUrl}/api/dxp/shoppingcart/validate/transactionitems`,
  },
  recipe: {
    authorize: `${environment.baseUrl}/api/dxp/processpayments/process/payments/auth/prescription`,
  },
  activeOrders: {
    getList: `${environment.baseUrl}/api/dxp/processpayments/orders/active`,
    getListProductPending: `${environment.baseUrl}/api/dxp/sapordersadapter/products/pending/withoutinvoice`,
    getPackagesSentActiveDetail: `${environment.baseUrl}/api/dxp/processpayments/orders/active/invoices`,
  },
  advisorInfo: {
    getListDoctors: `${environment.baseUrl}/api/dxp/advisor/advisor/doctorsinfo`,
    sendInvitationDoctor: `${environment.baseUrl}/api/dxp/advisor/invitation/doctor`,
    advisorInfo: `${environment.baseUrl}/api/dxp/advisor/advisorinfo?advisorCode=`,
  },
  catalogsProduct: {
    getListProductType: `${environment.baseUrl}/api/dxp/catalog/product`,
    getCatalogClassification: `${environment.baseUrl}/api/dxp/catalog/catalogs/clasification/doctor?cardcode=`,
    dermazoneProducts: `${environment.baseUrl}/api/dxp/catalog/dermazone/products`,
    getDownloadCatalogs: `${environment.baseUrl}/api/dxp/catalog/product/catalog?cattype=`,
    getSelectCatalogs: `${environment.baseUrl}/api/dxp/catalog/filters`,
    postSendNotificationMissingProduct: `${environment.baseUrl}/api/dxp/report/notificacion/missing/products`,
    generalSearch: `${environment.baseUrl}/api/dxp/catalog/general/product`,
  },
  profileAdviser: {
    getProfileInfo: `${environment.baseUrl}/api/dxp/advisor/advisorinfobyid`,
    saveProfileInfo: `${environment.baseUrl}/api/dxp/advisor/savepersonalinfo`,
    saveProfilePhoto: `${environment.baseUrl}/api/dxp/advisor/saveprofilepicture`,
    downloadDoctors: `${environment.baseUrl}/api/dxp/sapordersadapter/advisor/doctor/excel`,
  },
  containers: {
    getContainers: `${environment.baseUrl}/api/dxp/catalog/products/get/container`,
  },
  getPaymentTimes: {
    get: `${environment.baseUrl}/api/dxp/catalog/paymentmethodresponsetimes`,
  },
  incidents: {
    getIncidentType: `${environment.baseUrl}/api/dxp/catalog/incidences`,
    getInvoiceProducts: `${environment.baseUrl}/api/dxp/sapordersadapter/invoice`,
    createIncident: `${environment.baseUrl}/api/dxp/incidencia`,
    getInvoiceProductAdvisor: `${environment.baseUrl}/api/dxp/sapordersadapter/advisor/invoice`,
  },
  invoices: {
    getInvoicesPaid: `${environment.baseUrl}/api/dxp/sapordersadapter/payed/invoices`,
    getInvoicesPending: `${environment.baseUrl}/api/dxp/sapordersadapter/pending/invoices`,
    payinvoices: `${environment.baseUrl}/api/dxp/processpayments/process/invoicepayment`,
    getInvoicesInProcess: `${environment.baseUrl}/api/dxp/sapordersadapter/process/invoices`,
    getInvoicesInValidation: `${environment.baseUrl}/api/dxp/sapordersadapter/validation/invoices`,
    changeMethod: `${environment.baseUrl}/api/dxp/processpayments/process/changepayment/invoice`,
    deleteTransaction: `${environment.baseUrl}/api/dxp/processpayments/invoice/delete/pendingpayment`,
    showDetails: `${environment.baseUrl}/api/dxp/processpayments/invoice/`,
    showPaymentInfo: `${environment.baseUrl}/api/dxp/processpayments/invoice/pending/detail`,
    renewCode: `${environment.baseUrl}/api/dxp/processpayments/process/newpaynetcode/invoice`,
    validateInvoices: `${environment.baseUrl}/api/dxp/sapordersadapter/validate/exiting/invoices`,
    invoiceConfirmedAndProcess: `${environment.baseUrl}/api/dxp/sapordersadapter/validate/order/invoices`,
    createPayPalOrder: `${environment.baseUrl}/api/dxp/payments/payment/invoice/paypal/`,
    createPayPalOrderChange: `${environment.baseUrl}/api/dxp/payments/change/payment/invoice/paypal`,
    payPaypalInvoice: `${environment.baseUrl}/api/dxp/processpayments/process/invoicepayment/paypal`,
    changePaypalInvoice: `${environment.baseUrl}/api/dxp/processpayments/process/changepayment/invoice/paypal`,
  },
  advisor: {
    getAverageTickets: `${environment.baseUrl}/api/dxp/advisor/doctors/averagetickets`,
    getDinamicTicket: `${environment.baseUrl}/api/dxp/advisor/doctors/dynamicaveragetickets`,
    getCatalogs: `${environment.baseUrl}/api/dxp/catalog/clasification/advisor`,
  },
  utilities: {
    utilitiesRange: `${environment.baseUrl}/api/dxp/pedidosdxp/utilities/period`,
    utilitiesSave: `${environment.baseUrl}/api/dxp/pedidosdxp/utilities`,
    utilitiesFavorites: `${environment.baseUrl}/api/dxp/pedidosdxp/utilities/favorites`,
  },
  goals: {
    activeUsers: `${environment.baseUrl}/api/dxp/advisor/goals`,
    headers: `${environment.baseUrl}/api/dxp/advisor/goals/billing`,
    sales: `${environment.baseUrl}/api/dxp/advisor/goals/products/header`,
    salesProducts: `${environment.baseUrl}/api/dxp/advisor/goals/products/list`,
    refresh: `${environment.baseUrl}/api/dxp/advisor/goals/billing/refresh`,
  },
  missing: {
    product: `${environment.baseUrl}/api/dxp/report/missing/product`,
    getMissingActivesList: `${environment.baseUrl}/api/dxp/catalog/products/active`,
    getAutoCompleteOptions: `${environment.baseUrl}/api/dxp/catalog/autocomplete/missing/products`,
    activePrincipes: `${environment.baseUrl}/api/dxp/catalog/active/rawmaterial/relation`,
    getAutoContainers: `${environment.baseUrl}/api/dxp/catalog/containers`,
  },
  deleteItems: {
    delete: `${environment.baseUrl}/api/dxp/shoppingcart/cart/deleteitems`,
  },
  home: {
    options: `${environment.baseUrl}/api/dxp/catalog/home/images?type=`,
  },
  prescription: {
    getInfo: `${environment.baseUrl}/api/dxp/files/prescription/info`,
  },
  serviceQualifier: {
    getQuestions: `${environment.baseUrl}/api/dxp/report/poll?type=Pagos&cardCode=`,
    saveQuestions: `${environment.baseUrl}/api/dxp/report/poll/answers`,
  },
  whatsappUrl: `${environment.baseUrl}/api/dxp/catalog/params/contains/field?CustomerServiceWhatsappUrl=CustomerServiceWhatsappUrl`,
  promotions: `${environment.baseUrl}/api/dxp/catalog/promotions`,
  policies: `${environment.baseUrl}/api/dxp/catalog/policies`,
  oxxoPaymentLimit: `${environment.baseUrl}/api/dxp/catalog/params/contains/field?PaymentLimitOxxo=PaymentLimit&PaymentLimitCard=PaymentLimitCard&Webbinar=Webbinar&ActiveLabelMessage=ActiveLabelMessage`,
  minPiecesQuantity: `${environment.baseUrl}/api/dxp/catalog/params/contains/field?MinQuantityForCustomLabel=MinQuantityForCustomLabel`,
  conekta: {
    token: `${environment.baseUrl}/api/dxp/payments/conekta/token`,
    createCard: `${environment.baseUrl}/api/dxp/doctors/doctor/payment/cards`,
    list: `${environment.baseUrl}/api/dxp/doctors/doctor/payment/cards`,
    delete: `${environment.baseUrl}/api/dxp/doctors/doctor/payment/cards/delete`,
    setAsDefault: `${environment.baseUrl}/api/dxp/doctors/doctor/payment/cards/default`,
    update: `${environment.baseUrl}/api/dxp/doctors/doctor/payment/cards`,
  },
  credit: {
    validation: `${environment.baseUrl}/api/dxp/credit/validate/usercredit`,
  },
  discounts: {
    getAll: `${environment.baseUrl}/api/dxp/shoppingcart/shopcart/discountsmsgs`,
  },
  filters: {
    getFilters: `${environment.baseUrl}/api/dxp/sapordersadapter/filters/report`,
    getFiltersOrders: `${environment.baseUrl}/api/dxp/processpayments/filters/report`,
    clientWallet: `${environment.baseUrl}/api/dxp/sapordersadapter/get/doctorlist/report`,
    paymentAndBills: `${environment.baseUrl}/api/dxp/sapordersadapter/get/paymentinvoice/report`,
    tradeCube: `${environment.baseUrl}/api/dxp/sapordersadapter/get/comercialcube/report`,
    refreshClientsWallet: `${environment.baseUrl}/api/dxp/sapordersadapter/refresh/doctorlist/report`,
    refreshPaymentsBills: `${environment.baseUrl}/api/dxp/sapordersadapter/refresh/paymentinvoice/report`,
    refreshTradeCube: `${environment.baseUrl}/api/dxp/sapordersadapter/refresh/comercialcube/report`,
    refreshOrderReports: `${environment.baseUrl}/api/dxp/processpayments/get/openitemtracking/report`,
    getProductsSapDetails: `${environment.baseUrl}/api/dxp/sapordersadapter/saleorder/`,
    getGeneralFilters: `${environment.baseUrl}/api/dxp/catalog/filters/general`,
  },
  faqs: {
    topics: `${environment.baseUrl}/api/dxp/catalog/faqtopics`,
    faqs: `${environment.baseUrl}/api/dxp/catalog/faq/questions`,
  },
  quotation: {
    filterProducts: `${environment.baseUrl}/api/dxp/catalog/product/quotes`,
    discountPrices: `${environment.baseUrl}/api/dxp/discounts/discounts/quote/products`,
    downloadQuotation: `${environment.baseUrl}/api/dxp/files/advisor/quote`,
  },
  reports: {
    detail: `${environment.baseUrl}/api/dxp/sapordersadapter/report/openorders/detail/transaction`,
  },
  updateOrdersQuantity: {
    updatePieces: `${environment.baseUrl}/api/dxp/shoppingcart/cart/`,
  },
  paypal: {
    createOrderChangePayment: `${environment.baseUrl}/api/dxp/payments/change/payment/order/paypal`,
    onAproveChangePayment: `${environment.baseUrl}/api/dxp/processpayments/process/onapprove/change/transaction/status`,
    onCancelChangePayment: `${environment.baseUrl}/api/dxp/processpayments/process/oncancel/changepayment`,
  },
  encryp: {
    hashMessage: `${environment.baseUrl}/api/dxp/processpayments/hash`,
  },
  bbva: {
    createCarOrder: `${environment.baseUrl}/api/dxp/payments/payment/bbva/multipayments`,
    createInvoices: `${environment.baseUrl}/api/dxp/payments/payment/invoice/bbva/multipayments`,
    changeInvoicePayment: `${environment.baseUrl}/api/dxp/payments/change/invoice/bbva/multipayments`,
    getOrderDetail: `${environment.baseUrl}/api/dxp/processpayments/get/bbva/payment/detail`,
    successOrder: `${environment.baseUrl}/api/dxp/payments/public/response/payment/success/bbva/multipayments`,
    failureOrder: `${environment.baseUrl}/api/dxp/payments/public/response/payment/failed/bbva/multipayments`,
    successInvoice: `${environment.baseUrl}/api/dxp/payments/public/response/invoice/success/bbva/multipayments`,
    failureInvoice: `${environment.baseUrl}/api/dxp/payments/public/response/invoice/failed/bbva/multipayments`,
    successChange: `${environment.baseUrl}/api/dxp/payments/public/success/change/payment/bbva/multipayments`,
    failureChange: `${environment.baseUrl}/api/dxp/payments/public/failed/change/payment/bbva/multipayments`,
    successChangeInvoice: `${environment.baseUrl}/api/dxp/payments/public/success/change/invoice/bbva/multipayments`,
    failureChangeInvoice: `${environment.baseUrl}/api/dxp/payments/public/failed/change/invoice/bbva/multipayments`,
    transactions: `${environment.baseUrl}/api/dxp/payments/bbva/multipayments/`,
    cancelTransactions: `${environment.baseUrl}/api/dxp/payments/cancel/bbva/multipayments/request`,
    selectOrderToChange: `${environment.baseUrl}/api/dxp/payments/change/payment/bbva/multipayments`,
    getOrderChangedDetail: `${environment.baseUrl}/api/dxp/payments/bbva/payments`,
    getParams: `${environment.baseUrl}/api/dxp/catalog/bbva/parameters`,
    getCards: `${environment.baseUrl}/api/dxp/doctors/get/doctor/bbva/cards`,
    deleteCard: `${environment.baseUrl}/api/dxp/doctors/delete/doctor/bbva/card`,
  },
  promotionCodes: {
    getLines: `${environment.baseUrl}/api/dxp/catalog/promotional/codes/cataloglines`,
    getSublines: `${environment.baseUrl}/api/dxp/catalog/sublines`,
    getDiscountTypes: `${environment.baseUrl}/api/dxp/catalog/promotional/codes/discount/types`,
    getPromotionTypes: `${environment.baseUrl}/api/dxp/catalog/promotional/codes/types`,
    getSpecialties: `${environment.baseUrl}/api/dxp/catalog/promotional/codes/specialities`,
    uploadImage: `${environment.baseUrl}/api/dxp/coupons/email/image/promotionalcode`,
    savePromotion: `${environment.baseUrl}/api/dxp/coupons/promotionalcode`,
    paginate: `${environment.baseUrl}/api/dxp/coupons/promotionalcode`,
    usagaMetricsInfo: (code: string) =>
      `${environment.baseUrl}/api/dxp/coupons/promotions/${code}/graphics`,
    usageMetricsPaginate: `${environment.baseUrl}/api/dxp/processpayments/promotionalcode/usage/detail`,
    activateInactivate: `${environment.baseUrl}/api/dxp/coupons/update/status`,
    delete: `${environment.baseUrl}/api/dxp/coupons/delete/promotionalcode`,
    savePromotionProfilePhoto: `${environment.baseUrl}/api/dxp/coupons/user/saveprofilepicture`,
    getAdminPhoto: `${environment.baseUrl}/api/dxp/coupons/admin`,
    getLabels: `${environment.baseUrl}/api/dxp/catalog/labels`,
  },
  configurableParams: {
    getParams: `${environment.baseUrl}/api/dxp/catalog/params/contains/field`
  },
  payments: {
    validateMSI: `${environment.baseUrl}/api/dxp/payments/validate-msi`,
    msiEligibility: `${environment.baseUrl}/api/dxp/payments/conekta/msi-eligibility`,
  }
};

export const TokenExcludedEndpoints = ['login'];
